<template>

    <div class="or-separator">
        <span class="or-separator__line or-separator__line--left"></span>
        <span class="or-separator__text">Or</span>
        <span class="or-separator__line or-separator__line--right"></span>
    </div>

</template>